/**
 * Onboarding journey log — event type constants.
 *
 * These are the only event types we log across the onboarding flow.
 * Keeping them as a fixed list (instead of free-text strings scattered
 * across step files) is what lets us reconstruct a user's journey later
 * from DynamoDB in a consistent way.
 *
 * Full plan/reasoning: public/ONBOARDING_LOGGING_PLAN.md (section 2).
 */
export const LOG_EVENT_TYPE = {
  SCREEN_VIEW: 'SCREEN_VIEW',
  SCREEN_EXIT: 'SCREEN_EXIT',
  BUTTON_CLICK: 'BUTTON_CLICK',
  API_REQUEST: 'API_REQUEST',
  API_SUCCESS: 'API_SUCCESS',
  API_ERROR: 'API_ERROR',
  PROCESS_STARTED: 'PROCESS_STARTED',
  PROCESS_COMPLETED: 'PROCESS_COMPLETED',
  PROCESS_FAILED: 'PROCESS_FAILED',
  NAVIGATION: 'NAVIGATION',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  USER_REPORTED_ERROR: 'USER_REPORTED_ERROR',
};

/**
 * Log status values — kept separate from eventType so a single event type
 * (e.g. PROCESS_FAILED) always carries an explicit status too.
 */
export const LOG_STATUS = {
  STARTED: 'STARTED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

/**
 * Why a batch was flushed to the backend. Not required to reconstruct the
 * user journey, but cheap to send and useful when debugging the logging
 * pipeline itself (e.g. "were we losing logs on tab close?").
 */
export const FLUSH_REASON = {
  TIMER: 'timer',
  QUEUE_FULL: 'queue_full',
  RECONNECT: 'reconnect',
  TAB_HIDDEN: 'tab_hidden',
  RECOVERED: 'recovered', // leftover queue found in localStorage from a previous tab session
};
